import { useEffect, useState } from 'react';
import { ErrorService, ErrorServiceEventNames } from '../services/errorService';
import { FetchError } from '../utilities/error';

export function useErrorService(service: ErrorService): FetchError[] {
  const [errors, setErrors] = useState<FetchError[]>([]);

  useEffect(() => {
    const onCatchError = (): void => {
      setErrors([...service.errors]);
    };

    const onReset = (): void => {
      setErrors([]);
    };

    service.addEventListener(ErrorServiceEventNames.CATCH_ERROR, onCatchError);
    service.addEventListener(ErrorServiceEventNames.RESET, onReset);

    return (): void => {
      service.removeEventListener(ErrorServiceEventNames.CATCH_ERROR, onCatchError);
      service.removeEventListener(ErrorServiceEventNames.RESET, onReset);
    };
  }, [service]);

  return errors;
}
